import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  coords = {
    lat: 0,
    lng: 0,
  };

  address = '';

  startCoords = {
    lat: 0,
    lng: 0,
  };
  startAddress = '';

  endCoords = {
    lat: 0,
    lng: 0,
  };
  endAddress = '';

  constructor() {}

  setCoords(lat, lng) {
    this.coords.lat = lat;
    this.coords.lng = lng;
  }

  getCoords() {
    return this.coords;
  }

  setAddress(address) {
    this.address = address;
  }

  getAddress() {
    return this.address;
  }

  // START LOCATION
  setStartCoords(lat, lng) {
    this.startCoords.lat = lat;
    this.startCoords.lng = lng;
  }

  getStartCoords() {
    return this.startCoords;
  }

  setStartAddress(address) {
    this.startAddress = address;
  }

  getStartAddress() {
    return this.startAddress;
  }

  // END LOCATION
  setEndCoords(lat, lng) {
    this.endCoords.lat = lat;
    this.endCoords.lng = lng;
  }

  getEndCoords() {
    return this.endCoords;
  }

  setEndAddress(address) {
    this.endAddress = address;
  }

  geteEndAddress() {
    return this.endAddress;
  }
}
